import { render, staticRenderFns } from "./UserWillingnessToTravel.vue?vue&type=template&id=17fe1dcf&scoped=true&"
import script from "./UserWillingnessToTravel.vue?vue&type=script&lang=js&"
export * from "./UserWillingnessToTravel.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/user-willingness-to-travel.scss?vue&type=style&index=0&id=17fe1dcf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fe1dcf",
  null
  
)

export default component.exports